export const subscriptionExpiryAlertDismissedCookieName =
  'subscriptionExpiryGlobalAlertDismissed'
